import { render, staticRenderFns } from "./ChargerClientView.vue?vue&type=template&id=afb41bd0"
import script from "./ChargerClientView.vue?vue&type=script&lang=js"
export * from "./ChargerClientView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports